import { useEffect, useRef, useState } from "react";
import { track } from "../../../lib/analytics";

export function useScrollReveal<T extends HTMLElement>(
  threshold = 0.15,
  sectionName?: string,
) {
  const ref = useRef<T>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
          if (sectionName) {
            track("landing_section_viewed", { section: sectionName });
          }
        }
      },
      { threshold },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, sectionName]);

  return { ref, isVisible };
}
